import React, { useState } from 'react';
import MuiBox from '@material-ui/core/Box';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiCollapse from '@material-ui/core/Collapse';
import MuiKeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MuiKeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import MuiIconButton from '@material-ui/core/IconButton';
import MuiTypography from '@material-ui/core/Typography';

import SplitTrackBreakdownTable from './split-track-breakdown-table';

import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  expandedRow: {
    backgroundColor: '#f3f3f3',
  },
});

function SplitTrackRow({ classes, track }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const tableSplitsColumns = [
    {
      name: 'id',
      dataGetter: split => split.id,
      headerProps: () => ({ style: { width: '5%' } }),
      cellProps: {},
    },
    {
      name: 'Payee Name',
      dataGetter: split => split.payee?.payment_account?.group?.name || split.payee?.payment_account?.user?.name,
      headerProps: () => ({ style: { width: '20%' } }),
      cellProps: {},
    },
    {
      name: 'Payee Email',
      dataGetter: split => split.payee?.payment_account?.group?.email || split.payee?.payment_account?.user?.email,
      headerProps: () => ({ style: { width: '15%' } }),
      cellProps: {},
    },
    {
      name: 'Contributor Name',
      dataGetter: split => split.party?.full_name,
      headerProps: () => ({ style: { width: '15%' } }),
      cellProps: {},
    },
    {
      name: 'Roles',
      dataGetter: split => split.roles?.[0],
      headerProps: () => ({ style: { width: '10%' } }),
      cellProps: {},
    },
    {
      name: 'Wallet Address',
      dataGetter: split => split.payee?.payment_account?.wallet_address,
      headerProps: () => ({ style: { width: '15%' } }),
      cellProps: { style: { textOverflow: 'ellipsis', overflow: 'hidden' } },
    },
    {
      name: '%',
      dataGetter: split => split.percentage,
      headerProps: () => ({ style: { width: '10%' } }),
      cellProps: {},
    },
  ];

  return (
    <>
      <MuiTableRow className={classes.root}>
        <MuiTableCell component="th" scope="row">
          {track.id}
        </MuiTableCell>
        <MuiTableCell>{track.title}</MuiTableCell>
        <MuiTableCell>{track.isrc_code}</MuiTableCell>
        <MuiTableCell>{track.resource_type}</MuiTableCell>
        {track.has_royalties ? (
          <MuiTableCell style={{ color: 'red', fontWeight: 700 }}>Yes</MuiTableCell>
        ) : (
          <MuiTableCell style={{ color: 'green', fontWeight: 700 }}>No</MuiTableCell>
        )}
        <MuiTableCell style={{ width: '20%' }} className={classes.buttonCell} align="right">
          <MuiIconButton aria-label="expand row" onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? <MuiKeyboardArrowUpIcon /> : <MuiKeyboardArrowDownIcon />}
          </MuiIconButton>
        </MuiTableCell>
      </MuiTableRow>
      <MuiTableRow className={classes.expandedRow}>
        <MuiTableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <MuiCollapse in={isExpanded} timeout="auto" unmountOnExit>
            <MuiBox m={1}>
              <MuiTypography variant="h6" gutterBottom>
                Track Splits
              </MuiTypography>
              <SplitTrackBreakdownTable track={track} columns={tableSplitsColumns} />
            </MuiBox>
          </MuiCollapse>
        </MuiTableCell>
      </MuiTableRow>
    </>
  );
}

export default withStyles(styles)(SplitTrackRow);
